import React from 'react';
import { Section } from '../ui/Section';
import { X } from 'lucide-react';
export function WhyFailed() {
  const failures = [{
    title: 'The Zillow Trap',
    desc: 'Zillow and Redfin are "Display Cases" designed to maximize the seller\'s profit, not your savings.'
  }, {
    title: 'The 1990s Strategy',
    desc: 'Saving for 20% down is an outdated strategy that is being eaten alive by 2026 inflation.'
  }, {
    title: 'The Realtor Bias',
    desc: "Traditional Realtors often avoid auctions because there's no easy 3% commission for them to collect."
  }, {
    title: 'The Legal Intimidation',
    desc: 'You\'ve been intimidated by legal jargon like "Lis Pendens" and "Quitclaim" designed to keep outsiders away.'
  }];
  return <Section theme="black" className="border-b border-gold-hairline" data-id="element-220">
      <div className="mb-6 flex flex-col items-center" data-id="element-221">
        <div className="flex items-center gap-4 mb-4" data-id="element-222">
          <div className="h-[1px] w-8 bg-gold/30" data-id="element-223"></div>
          <span className="text-gold text-xs font-semibold tracking-[0.2em] uppercase" data-id="element-224">
            Why What You Tried Didn't Work
          </span>
          <div className="h-[1px] w-8 bg-gold/30" data-id="element-225"></div>
        </div>
      </div>

      <h2 className="text-3xl md:text-4xl font-serif font-medium mb-16 text-center max-w-2xl mx-auto text-bone" data-id="element-226">
        The system is designed to keep you in the retail market.
      </h2>

      <div className="grid md:grid-cols-2 gap-6" data-id="element-227">
        {failures.map((item, idx) => <div key={idx} className="bg-graphite p-8 border border-gold-hairline border-l-2 border-l-gold shadow-editorial-dark flex gap-6 items-start hover:border-gold/40 transition-colors duration-300" data-id="element-228">
            <div className="shrink-0 mt-1" data-id="element-229">
              <X className="w-5 h-5 text-gold" data-id="element-230" />
            </div>
            <div data-id="element-231">
              <h3 className="text-xl font-serif font-medium mb-3 text-bone" data-id="element-232">
                {item.title}
              </h3>
              <p className="text-bone-muted leading-relaxed" data-id="element-233">{item.desc}</p>
            </div>
          </div>)}
      </div>
    </Section>;
}